import { useDashData } from "../hooks/useDashData";
import PageHeader from "../components/layout/PageHeader";
import AiInsights from "../components/dashboard/AiInsights";

export default function AiAdvisor() {
  const { data: insights, reload } = useDashData("/ai/insights", { withDates: false });

  return (
    <div className="space-y-6 animate-fade-up">
      <PageHeader title="AI Strategic Advisor"
        subtitle="Ask questions in plain English and get AI-generated budget & fatigue insights" />
      <AiInsights insights={insights || []} onRefresh={reload} />
    </div>
  );
}
